export default "select *\nfrom sys.sequence\nwhere database_id = $(database_id)\n"